
jQuery(document).ready(function ($) {
  if ($(".comp-dropdown-search").length > 0) {
    $(".search.dropdown-trigger").click(function () {
      $(this).next(".comp-dropdown-search").toggleClass("visible");
      $(".search-bar-input").focus();
    });
  }
});
